var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:_vm.divClass},[_c('iframe',{attrs:{"src":_vm.frameSrcComputed}})]),(_vm.isAuth)?_c('div',[(this.changeData)?_c('v-btn',{on:{"click":_vm.pushChangeContent}},[_vm._v("Изменить")]):_vm._e()],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }